import React, { forwardRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useChartSettings } from '../hooks/useChartSettings';
import { axisSettings, AxisType, commonSettings } from '../charts.constants';
import { theme } from '../../../../theme/theme';
import { Chart } from '../Chart';
import { RefObjectForHighchartsReact } from '../Chart.types';

export const chartSettings: Highcharts.Options = {
  ...commonSettings,

  chart: {
    type: 'column',
    spacingTop: 20,
    spacingRight: 20,
    style: {
      fontFamily: theme.fontFamily,
    },
  },
};

export interface ColumnChartProps extends HighchartsReact.Props {
  series: {
    name: string;
    data: number[];
  }[];
  categories: (string | number)[];
  isStacked?: boolean;
  customSettings?: Record<string, any>;
  xAxisType?: AxisType;
  yAxisType?: AxisType;
}

export const ColumnChart = forwardRef<RefObjectForHighchartsReact, ColumnChartProps>(
  (
    {
      series,
      categories = [],
      isStacked,
      customSettings = {},
      xAxisType = 'decimal',
      yAxisType = 'decimal',
      ...rest
    },
    ref,
  ) => {
    const settings = useChartSettings({
      series,
      settings: chartSettings,
      customSettings: {
        ...customSettings,
        plotOptions: {
          column: {
            ...customSettings?.plotOptions?.column,
            stacking: isStacked ? 'normal' : undefined,
            borderRadius: 4,
          },
          ...customSettings?.plotOptions,
        },
        xAxis: {
          categories,
          ...customSettings?.xAxis,
          ...axisSettings[xAxisType],
        },
        yAxis: {
          ...customSettings?.yAxis,
          ...axisSettings[yAxisType],
        },
      },
    });

    return <Chart ref={ref} options={settings} {...rest} />;
  },
);
